<script>
export default {
    name: 'IconHome'
}
</script>
<template>
    <svg
        class="base-icon icon-home"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M31.753 8L56 26v30H38V40H26v16H8V26L31.753 8z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
